import { useState, useEffect } from "react";
import Login from "./Login";
import ClientDashboard from "./ClientDashboard";
import AdminDashboard from "./AdminDashboard";

export default function App() {
  const [role, setRole] = useState(() => localStorage.getItem("role") || null);
  const [viewMode, setViewMode] = useState("dashboard");
  const [lightMode, setLightMode] = useState(
    () => localStorage.getItem("theme") === "light"
  );


  useEffect(() => {
    document.documentElement.setAttribute("data-theme", lightMode ? "light" : "dark");
    localStorage.setItem("theme", lightMode ? "light" : "dark");
  }, [lightMode]);

  const toggleTheme = () => setLightMode(m => !m);

  // Validate stored token on page load — log out if expired
  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    const storedToken = localStorage.getItem("token");
    if (storedRole && storedToken) {
      fetch("/api/status", { headers: { Authorization: `Bearer ${storedToken}` } })
        .then(r => { if (!r.ok) handleLogout(); })
        .catch(() => handleLogout());
    }
  }, []);

  // 20-minute inactivity logout
  useEffect(() => {
    if (!role) return;
    let timer;
    const TWENTY_MIN = 20 * 60 * 1000;
    const reset = () => { clearTimeout(timer); timer = setTimeout(handleLogout, TWENTY_MIN); };
    const events = ["mousemove","mousedown","keydown","touchstart","scroll","click"];
    events.forEach(e => window.addEventListener(e, reset));
    reset();
    return () => { clearTimeout(timer); events.forEach(e => window.removeEventListener(e, reset)); };
  }, [role]);

  const handleLogin = (userRole) => {
    localStorage.setItem("role", userRole);
    setRole(userRole);
    setViewMode("dashboard");
  };

  const handleLogout = () => {
    setRole(null);
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("username");
    setViewMode("dashboard");
  };

  if (!role) {
    return <Login onLogin={handleLogin} lightMode={lightMode} toggleTheme={toggleTheme} />;
  }


  if (role === "admin") {
    if (viewMode === "client-view") {
      return <ClientDashboard onLogout={handleLogout} isAdminView={true}
               onBackToAdmin={() => setViewMode("dashboard")}
               lightMode={lightMode} toggleTheme={toggleTheme} />;
    }
    return <AdminDashboard onLogout={handleLogout} onViewModeChange={setViewMode}
             viewMode={viewMode} lightMode={lightMode} toggleTheme={toggleTheme} />;
  }

  return <ClientDashboard onLogout={handleLogout} lightMode={lightMode} toggleTheme={toggleTheme} />;
}
